<template>
  <div>
    <div class="serchBox">
      <!-- <div class="logoImg img">
        <img
          src="../../assets/img/logo-p.png"
          alt=""
          srcset=""
        />
      </div> -->
      <div class="inpBox">
        <div class="inp">
          <div class="search">
            <div class="iconfont icon-search"></div>
          </div>
          <div class="shu"></div>
          <input
            type="text"
            placeholder="请输入学校名称搜索"
            v-model="searChTxt"
            @keyup.enter="searchClick"
            name=""
            id=""
          />
          <div class="searchBtn" @click="searchClick">搜索</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftCont">
        <div class="headCont">
          <div class="typeList">
            <div class="type on">高校院校列表</div>
            <div class="type">大学生实习</div>
            <div class="type">人才政策</div>
            <div class="type">档案查询</div>
          </div>
          <div class="lxList">
            <!-- <div class="lxLi">
              <div class="name">院校类型:</div>
              <div class="texts">
                <div class="text">高中</div>
                <div class="text">初中</div>
                <div class="text">小学</div>
              </div>
            </div> -->
            <!-- <div class="lxLi">
              <div class="name">学制类型:</div>
              <div class="texts">
                <div class="text">三年制</div>
                <div class="text">六年制</div>
              </div>
            </div>
            <div class="lxLi">
              <div class="name">招生对象:</div>
              <div class="texts">
                <div class="text">本地户籍</div>
                <div class="text">外地户籍</div>
              </div>
            </div>
            <div class="lxLi">
              <div class="name">学期学费:</div>
              <div class="texts">
                <div class="text">2000元</div>
                <div class="text">3000元</div>
                <div class="text">4000元</div>
                <div class="text">5000元</div>
                <div class="text">6000元</div>
                <div class="text">7000元</div>
                <div class="text">8000元</div>
                <div class="text">9000元</div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="mapBox">
          <div :style="{ width: '100%', height: '100%' }" id="getMap"></div>
        </div>
        <div class="list">
          <div class="li" @click="jump(item.id, item)" v-for="item in list">
            <div class="logo">
              <img :src="$imgUrl + item.logo" alt="" />
            </div>
            <div class="box">
              <div class="titleBox">
                <div class="name">{{ item.name }}</div>
                <!-- <div class="dzBox">
                  <div class="iconfont icon-coordinates"></div>
                  <div class="txt">北京市 海淀区</div>
                </div> -->
              </div>
              <div class="texts">
                <div class="text">{{ item.address }}</div>
                <!-- <div class="text">四年制</div>
                <div class="text">本地户籍</div>
                <div class="text">3000元</div>
                <div class="text">2000人</div>
                <div class="text">共46班</div>
                <div class="text">市重点高中</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ritCont">
        <LoginZj />
        <div class="ggCont">广告位招租</div>
        <!-- <div class="cont">
          <div class="headBox">学校咨询</div>
          <div class="ggBox">
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div class="headBox">院校推荐</div>
          <div class="xxBox">
            <div class="img">
              <img
                src="https://static-data.gaokao.cn/upload/logo/140.jpg"
                alt=""
              />
            </div>
            <div class="name">清华大学</div>
          </div>
          <div class="xxBox">
            <div class="img">
              <img
                src="https://static-data.gaokao.cn/upload/logo/140.jpg"
                alt=""
              />
            </div>
            <div class="name">清华大学</div>
          </div>
          <div class="xxBox">
            <div class="img">
              <img
                src="https://static-data.gaokao.cn/upload/logo/140.jpg"
                alt=""
              />
            </div>
            <div class="name">清华大学</div>
          </div>
          <div class="xxBox">
            <div class="img">
              <img
                src="https://static-data.gaokao.cn/upload/logo/140.jpg"
                alt=""
              />
            </div>
            <div class="name">清华大学</div>
          </div>
          <div class="xxBox">
            <div class="img">
              <img
                src="https://static-data.gaokao.cn/upload/logo/140.jpg"
                alt=""
              />
            </div>
            <div class="name">清华大学</div>
          </div>
          <div class="xxBox">
            <div class="img">
              <img
                src="https://static-data.gaokao.cn/upload/logo/140.jpg"
                alt=""
              />
            </div>
            <div class="name">清华大学</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import TiandituLoader from "@/assets/js/tianditu";
import LoginZj from "../component/loginZj.vue";

export default {
  components: {
    LoginZj,
  },
  name: "",
  data() {
    return {
      searChTxt: "",
      queryParam: {
        lat: "28.560603",
        lng: "121.3332",
      },
      center: [121.3332, 28.560603],
      maplist: [
        {
          lat: "28.560603",
          lng: "121.3332",
          name: "地址1",
        },
      ],
      judge: true,
      page: {
        pageNo: -1,
        // pageSize: 10,
      },
      list: [],
      totalCount: 0,
    };
  },
  created() {
    this.listGet();
  },
  methods: {
    searchClick() {
      this.page.name = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.listGet();
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/school_gets", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
          }
          this.list = res.data;
          this.mapGet();
        } else {
          this.list = [];
        }
      });
    },
    // typeGet(){
    //   this.$get('/nozzle/web/duration').then(res=>{
    //     console.log(res);

    //   })
    // },
    mapGet() {
      let that = this;
      TiandituLoader.load().then((Tianditu) => {
        that.showMap(Tianditu);
      });
    },
    showMap(Tianditu) {
      let maplist = this.list;
      this.map = new Tianditu.Map("getMap", {
        resizeEnable: true,
        center: [maplist[0].lng, maplist[0].lat],
        zoom: 11,
      });
      if (maplist) {
        let markers = [];
        for (let i = 0; i < maplist.length; i++) {
          let html = {
            content:
              '<div class="mapBox"><div class="img"><img src="' +
              this.$imgUrl +
              maplist[i].logo +
              '" alt=""/></div><div class="name">' +
              maplist[i].name +
              "</div></div>",
            direction: "right",
          };
          var marker = new Tianditu.Marker({
            position: [maplist[i].lng, maplist[i].lat],
            offset: new Tianditu.Pixel(-13, -30),
            label: html,
          });
          marker.on("click", (e) => {
            console.log(i);
            this.$router.push({
              path: "/schCont",
              query: {},
            });
          });
          markers.push(marker);
        }
        this.map.add(markers);
      }
      // 添加点坐标
      // this.map.add(this.marker);
    },
    jump(id, item) {
      if (item.is_url == 0) {
        // this.$router.push({
        //   path: "/schCont",
        //   query: {
        //     id,
        //   },
        // });
        window.open("#/schCont?id=" + id);
      } else {
        window.open(item.url);
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.serchBox {
  display: flex;
  justify-content: center;
  padding: 25px 55px;
  padding-right: 70px;
  padding-bottom: 5px;
  align-items: center;
  width: 1280px;
  margin: auto;
  box-sizing: border-box;
  margin-bottom: 10px;
  .logoImg {
    width: 150px;
  }

  .inpBox {
    width: calc(100% - 70px);
    box-sizing: border-box;

    .inp {
      border: 2px solid #1a78ec;
      background-color: #fff;
      width: 100%;
      height: 50px;
      border-radius: 10px;
      display: flex;
      overflow: hidden;
      align-items: center;
      position: relative;

      .search {
        width: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .iconfont {
          font-size: 24px;
          color: #999;
        }
      }

      .shu {
        width: 2px;
        height: 20px;
        background-color: #c9c9c9;
      }

      input {
        width: calc(100% - 67px);
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;
      }

      .searchBtn {
        cursor: pointer;
        width: 90px;
        height: calc(100% - 4px);
        position: absolute;
        right: 2px;
        top: 2px;
        background-color: #1a78ec;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.content {
  display: flex;
  width: 1280px;
  margin: auto;
  padding: 5px;

  .leftCont {
    width: calc(100% - 380px);

    .headCont {
      border-radius: 10px;
      background-color: #fff;
      padding: 20px;
      padding-bottom: 15px;

      .typeList {
        height: 40px;
        border-bottom: 1px solid #16a2ff;
        display: flex;

        .type {
          width: 150px;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          color: #333;
          position: relative;
          cursor: pointer;
          border-radius: 8px 8px 0 0;
          text-align: center;
          transition: all 0.2s;
        }

        .on {
          background: linear-gradient(91deg, #2a9fff, rgb(0, 140, 255) 99.9%);
          color: #fff;
        }
      }

      .lxList {
        padding: 20px 0 0;

        .lxLi {
          margin-bottom: 10px;
          display: flex;

          .name {
            width: 85px;
            color: #666;
          }

          .texts {
            width: calc(100% - 85px);
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 5px;

            .text {
              margin-right: 20px;
              color: #111;
            }
          }
        }

        .lxLi:last-child {
          margin-bottom: 0;
        }
      }
    }

    .mapBox {
      height: 300px;
      margin-top: 15px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #fff;
    }

    .list {
      margin-top: 15px;

      .li {
        border-radius: 10px;
        background-color: #fff;
        padding: 20px 20px;
        display: flex;
        margin-bottom: 5px;

        .logo {
          width: 210px;
          height: 60px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .box {
          width: calc(100% - 210px);
          padding-left: 15px;
          box-sizing: border-box;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .titleBox {
            display: flex;
            align-items: center;

            .name {
              font-size: 20px;
              margin-right: 12px;
              font-weight: 600;
              cursor: pointer;
            }

            .dzBox {
              border: 1px solid #c9c9c9;
              padding: 0 5px 0 2px;
              border-radius: 25px;
              height: 25px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #888;
              position: relative;
              top: 1px;
            }
          }

          .texts {
            display: flex;
            align-items: center;

            .text {
              margin-right: 15px;
              background-color: #f0f3f7;
              border-radius: 5px;
              padding: 3px 10px;
              font-size: 12px;
              color: #666;
            }
          }
        }
      }
    }
  }

  .ritCont {
    width: 380px;
    padding-left: 15px;
    box-sizing: border-box;

    .ggCont {
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 180px;
      color: #9c9c9c;
      font-size: 18px;
      margin-bottom: 20px;
    }

    .cont {
      background-color: #fff;
      margin-top: 15px;
      border-radius: 5px;
      overflow: hidden;

      .headBox {
        padding: 0 20px;
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 47px;
        border-bottom: 1px solid #ededed;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        min-width: 0;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-align: center;
        align-items: center;
      }

      .ggBox {
        padding: 20px;

        .textBox {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          cursor: pointer;

          .name {
            width: calc(100% - 0px);
          }

          .time {
            width: 80px;
            text-align: right;
          }
        }

        .textBox:last-child {
          margin-bottom: 0;
        }
      }

      .xxBox {
        display: flex;
        padding: 10px 15px 0 15px;
        align-items: center;

        .img {
          width: 26px;
          height: 26px;
          margin-right: 10px;
        }

        .name {
          font-size: 15px;
        }
      }

      .xxBox:last-child {
        padding-bottom: 10px;
      }
    }
  }
}

/deep/.tdt-label {
  border: none;
}

/deep/.mapBox {
  display: flex;
  align-items: center;
  border-radius: 5px;

  .img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .name {
    font-size: 12px;
  }
}
</style>
